"use strict";
window._theme = window._theme || {};

_theme.handleBundleATC = function(){

  if($('.cm-bundle-form-wrapper').length === 0) return;

  let formHTML = $('.cm-bundle-form-wrapper').html();
  let addedBundleMes = $('.addedMessageBundleText');

  $(document).on('click','button.cm-add-bndle',function(evt){
    evt.preventDefault();
    evt.stopPropagation();

    const $self = $(this);
    $(this).addClass('click-processing').attr('disabled', true);
    $('.cm-bundle-form-wrapper form').remove();
    $(this).after(formHTML);

    const varID = $(this).closest('.bundle-proItem').find('span.variant.cmVariant').attr('data-id');
    $('form#add-to-cart-quickview-form input[name="id"]').val(varID);
    $('form#add-to-cart-quickview-form input[name="quantity"]').attr('data-qv-qtt-id',"quantity__"+varID);
   
    const $statusAnnounceElem = $(this).parent().find(addedBundleMes);
    _theme.toggleLoading(1);
    $statusAnnounceElem.text("Please wait, adding product to the cart");

    // Do Not Remove Code - Add Properties for GWP Discount
    let properties = {};
    let bundleVarIdElement = $(this).closest(".grid-btns").find("[data-bundleVarId]");
    if (bundleVarIdElement.length > 0) {
        properties["_bundleVarId"] = bundleVarIdElement.val() || null;
    }
    // Do Not Remove Code - Add Properties for GWP Discount

    _theme.Helpers.addProductToCart(varID,1,properties, function(resp){
      _theme.MiniCart.lineItemChangeCallBack(resp, function(){
        $statusAnnounceElem.text('item added to your cart successfully');
        _theme.toggleLoading();
        _theme.toggleSideCart(1, null, true);
        $('form#add-to-cart-quickview-form').remove();
        $self.removeAttr('disabled');
        $self.removeClass('click-processing');
      });
    }, function(err){
      console.error(err)
    });

  });
}

$(document).ready(function() {
  _theme.handleBundleATC();

  $('.collection-des-full ol, collection-des-full ul').attr('role','list')
  $('.collection-des-full ol li, collection-des-full ul li').attr('role','listitem')

  if (_theme.isMobile) {
    const title = document.querySelector('.js-title-mob');
    const titledesk = document.querySelector('.js-title-desk');
    const descMob = document.querySelector('.collection-page-title-header.visible-mobile');
    const descdesk = document.querySelector('.collection-page-title-header.visible-desktop');
    
    if (title) {
      const div = document.createElement('h1');
      div.className = title.className;
      div.textContent = title.textContent;
      title.parentNode.replaceChild(div, title);
    }
    
    if (titledesk) {
      const div = document.createElement('div');
      div.className = titledesk.className;
      div.textContent = titledesk.textContent;
      titledesk.parentNode.replaceChild(div, titledesk);
    }

    if (descMob) {
      const div = document.createElement('h2');
      div.className = descMob.className;
      div.textContent = descMob.textContent;
      descMob.parentNode.replaceChild(div, descMob);
    }

    if (descdesk) {
      const div = document.createElement('div');
      div.className = descdesk.className;
      div.textContent = descdesk.textContent;
      descdesk.parentNode.replaceChild(div, descdesk);
    }
  }
  const elements = document.querySelectorAll('.collection-des ul li[role="presentation"]');
  if (elements && elements.length > 0) {
    elements.forEach(el => {
      if (el && typeof el.removeAttribute === 'function') {
        el.removeAttribute('role');
      }
    });
  } else {
    console.log('No elements with role="presentation" found.');
  }  
});